export default {"src":"/_next/static/media/megaphone_regular.c741886f.svg","height":24,"width":24};